import { Map } from 'immutable';
import { createReducer } from 'redux-act';

import PlaceLayouts from '../../models/interfaces/layout/PlaceLayouts';
import Place from '../../models/interfaces/Place';
import { placeFetched } from '../../store/actions/place/fetchPlace';
import { placeUpdated } from '../../store/actions/place/updatePlace';
import { authenticationRequired } from '../actions/authentication/authenticationRequired';
import { logout } from '../actions/authentication/logout';
import { placeLayoutsFetched } from '../actions/place/fetchPlaceLayouts';

export interface PlaceReducerState {
  readonly placeLayouts: Map<string, PlaceLayouts>;
  readonly places: Map<string, Place>;
}

const defaultState: PlaceReducerState = {
  placeLayouts: Map<string, PlaceLayouts>(),
  places: Map<string, Place>(),
};

const placeReducer = createReducer<PlaceReducerState>({}, defaultState);

placeReducer.on(placeLayoutsFetched, (state, { placeLayouts }) => ({
  ...state,
  placeLayouts: state.placeLayouts.set(placeLayouts.placeUuid, placeLayouts),
}));

placeReducer.on(placeFetched, (state, { place }) => ({
  ...state,
  places: state.places.set(place.uuid, place),
}));

placeReducer.on(placeUpdated, (state, { place }) => ({
  ...state,
  places: state.places.set(place.uuid, place),
}));

placeReducer.on(logout, () => defaultState);

placeReducer.on(authenticationRequired, () => defaultState);

export default placeReducer;
